var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationsEmail({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 17,
    viewBox: "0 0 23 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.222 0.166687H1.77756C1.4092 0.166687 1.05594 0.313016 0.795468 0.573483C0.535001 0.83395 0.388672 1.18722 0.388672 1.55558V15.4445C0.388672 15.8128 0.535001 16.1661 0.795468 16.4266C1.05594 16.687 1.4092 16.8334 1.77756 16.8334H21.222C21.5904 16.8334 21.9436 16.687 22.2041 16.4266C22.4646 16.1661 22.6109 15.8128 22.6109 15.4445V1.55558C22.6109 1.18722 22.4646 0.83395 22.2041 0.573483C21.9436 0.313016 21.5904 0.166687 21.222 0.166687ZM20.1526 15.4445H2.93034L7.79145 10.4167L6.79145 9.45141L1.77756 14.6389V2.61113L10.4095 11.2014C10.6697 11.4601 11.0217 11.6053 11.3887 11.6053C11.7556 11.6053 12.1076 11.4601 12.3678 11.2014L21.222 2.39585V14.5486L16.1109 9.43752L15.1317 10.4167L20.1526 15.4445ZM2.68728 1.55558H20.097L11.3887 10.2153L2.68728 1.55558Z",
    fill: "#00C8A0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationsEmail);
export default __webpack_public_path__ + "static/media/NotificationsEmail.39b85bb329e3cf4abee816fab58376a5.svg";
export { ForwardRef as ReactComponent };